import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Pay} from 'com/gongxigames/math/core/game/Pay';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {ReelsCascadingModule, ReelsCascadingStates, ReelsCascadingView} from '@gongxigames/framework/slot/modules/reelsCascading';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {FreeSpinsModule} from '@gongxigames/framework/slot/modules/freespins';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';
import {BuyBonusPopUpEvents} from '@gongxigames/framework/slot/modules/buyBonus';
import {CancelStartSpinReason} from '@gongxigames/framework/slot/events';
import {Spin} from 'com/gongxigames/math/core/game/Spin';

export class ReelsCascadingBasicState extends ModuleState<ReelsCascadingView, ReelsCascadingModule> {
    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStartedByButton.bind(this));
        this.setEventHandler('Autoplay.START_SPIN', this.goToReleaseSymbolsState.bind(this));
        this.setEventHandler('General.BuyFeature.BUY', this.goToReleaseSymbolsState.bind(this));
        this.setEventHandler(FreeSpinsModule.FREESPIN_START_SPIN, this.goToReleaseSymbolsState.bind(this));
        this.setEventHandler(FlowModuleEvents.RESPIN_WIN, this.goToReleaseSymbolsState.bind(this));
        this.setEventHandler(WinPresentationEvents.INITIAL_ANIMATION_STARTED, this.onInitialAnimationStarted.bind(this));
        this.setEventHandler(WinPresentationEvents.PAY_ANIMATION_STARTED, this.onPayAnimationStarted.bind(this));
        this.setEventHandler(FlowModuleEvents.FREESPINS_RESTORED, this.updateReelSet.bind(this));
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOutStarted.bind(this));
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));
        this.setEventHandler(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuyButtonClicked.bind(this));
    }

    protected canStartSpin(): boolean {
        return this.module.logic.nextAction !== Action.SPIN || this.module.logic.canSpin(this.module.logic.getTotalBet());
    }

    protected onSpinStartedByButton(): void {
        if (!this.module.canSpinBySpinButton) {
            return;
        }

        if (this.canStartSpin()) {
            this.goToReleaseSymbolsState();
        } else {
            this.emit('General.Flow.cancelStartSpin', {
                reason: CancelStartSpinReason.INSUFFICIENT_FUNDS,
                balanceRefreshCallback: this.onSpinStartedByButton.bind(this),
            });
        }
    }

    protected onInitialAnimationStarted(pays: Pay[]): void {
        for (const pay of pays) {
            this.module.hideByPayPosition(pay);
        }
    }

    protected onPayAnimationStarted(pay: Pay): void {
        this.view.setAllSymbolsVisible(true);
        this.module.hideByPayPosition(pay);
    }

    protected onPopupFadeOutStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.updateReelSet();
        }

        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.restoreReelsetAfterFS();
        }
    }
    protected onPopupStarted(id: symbol, type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO || type === GenericPopupType.FREESPIN_RETRIGGER) {
            this.view.setAllSymbolsVisible(true);
        }
    }

    protected onBuyButtonClicked(): void {
        this.view.setAllSymbolsVisible(true);
    }

    protected updateReelSet(): void {
        this.module.restoreSymbols(this.module.initialStopPositions);
    }

    protected restoreReelsetAfterFS(): void {
        const spin: Spin = this.module.logic.getSessionForFreeSpinsWinningRound();

        this.module.restoreSymbols(spin.reelPositions);
    }

    protected goToReleaseSymbolsState(): void {
        this.module.gotoState(ReelsCascadingStates.RELEASE_SYMBOLS_STATE);
    }
}